import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://a77ca6cdb17f478b294d3a4526a93abe@o4506865428267008.ingest.us.sentry.io/4506865430233088",
  debug: false,
  environment: import.meta.env.PUBLIC_VERCEL_ENV,
  release: import.meta.env.PUBLIC_VERCEL_GIT_COMMIT_SHA,
  tracesSampleRate: 1,
  integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
});